/**
 * Encrypts a JSON-serialisable body with AES-256-GCM.
 * Wire format: base64( IV[12] || ciphertext+authTag[n+16] )
 */
export async function encryptBody(body: unknown, aesKey: CryptoKey): Promise<string> {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const plaintext = new TextEncoder().encode(JSON.stringify(body));

  // Web Crypto appends the 16-byte GCM auth tag at the end of the output automatically.
  const ciphertext = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, aesKey, plaintext);

  const combined = new Uint8Array(12 + ciphertext.byteLength);
  combined.set(iv, 0);
  combined.set(new Uint8Array(ciphertext), 12);

  let binary = '';
  for (let i = 0; i < combined.byteLength; i++) binary += String.fromCharCode(combined[i]);
  return btoa(binary);
}
